/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { shape, func, array, bool, number, string } from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import p from 'polyglot/polyglot';

import { getShortlist as getShortlistAction } from 'actions/shortlist';

import Spinner from 'components/Spinner/Spinner';
import ProfileCard from 'components/ProfileCard/ProfileCard';
import BackButton from 'components/BackButton/BackButton';

import styles from './talents.scss';

/**
 * This is the LikesList component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export class LikesList extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    match: shape({
      params: shape({
        shortlistId: string.isRequired,
      }).isRequired,
    }).isRequired,
    auth: shape({
      token: string.isRequired,
    }).isRequired,
    shortlist: shape({
      loading: bool,
      likes: shape({
        talent_count: number,
        talents_by_skill: array,
      }),
    }).isRequired,
    getShortlist: func.isRequired,
  };

  componentDidMount() {
    const {
      auth: { token },
      match: { params },
      shortlist: {
        likes: { talent_count },
      },
      getShortlist,
    } = this.props;

    // If talent count is less then or 0 we always load,
    // otherwise we cache the results.
    if (talent_count <= 0) {
      getShortlist(token, params.shortlistId);
    }
  }

  renderTalents() {
    const {
      shortlist: {
        loading,
        likes: { talent_count, talents_by_skill },
      },
    } = this.props;

    if (loading) {
      return (
        <div className={styles.spinner}>
          <Spinner medium />
        </div>
      );
    }

    if (talent_count > 0) {
      return talents_by_skill.map(({ talents }) =>
        talents.map(talent => (
          <div className={styles.item} key={talent.talent_id}>
            <ProfileCard {...talent} />
          </div>
        ))
      );
    }

    return (
      <div className={styles.description}>
        <p>{p.t('talents.shortlist.likes.empty')}</p>
      </div>
    );
  }

  /**
   * Render LikesList.
   *
   * @return {Object}
   */
  render() {
    return (
      <>
        <BackButton />
        <section className={styles.wrapper}>
          <div className={styles.container}>
            <div className={styles.talents}>
              <header className={styles.header}>
                <div className={styles.headerContent}>
                  <h1>{p.t('talents.shortlist.likes.title')}</h1>
                </div>
              </header>

              <section className={styles.items}>{this.renderTalents()}</section>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default withRouter(
  connect(
    ({ auth, shortlist }) => ({ auth, shortlist }),
    {
      getShortlist: getShortlistAction,
    }
  )(LikesList)
);
